import request from "../utils/request";


export const Login = (data) => {    // 登录
  return request({
    url: '/BasicData.UserLogin/Login',
    method: 'POST',
    data,
  })
}

export const SecondAuth = (data) => {    // 登录
  return request({
    url: '/BasicData.UserLogin/SecondAuth',
    method: 'POST',
    data,
  })
}

export const GetMenuList = (data) => {    // 获取有权限的菜单栏
  return request({
    url: '/Common.Permit/QueryMultiUIRes',
    method: 'POST',
    data
  })
}

export const GetAllMenuList = (data) => {     // 获取全部菜单栏
  return request({
    url: '/Common.Permit_UIRes/Query',
    method: 'POST',
    data
  })
}

// 流程查询
export function WorkflowQuery(data, path) {
  return request({
    url: `/BasicData.WorkflowQuery/${path}`,
    method: 'POST',
    data
  })
}

// 档案调阅审批通过
export function ArchivedBorrowing(data, path) {
  return request({
    url: `/BasicData.ArchivedFileWorkflow/${path}`,
    method: 'POST',
    data
  })
}

// 通过/驳回中标跟进流程
export function ApproveBidProjectTraceWorkflow(action, workflowId, actionRemark = '通过', url, deviceType = 0) {
  let entity = "BasicData";
  switch (url) {
    case "ChannelCostAndBusierProxyPayRefundWorkflow":
      entity = "Bidding"
      break;
    default:
      entity = "BasicData"
      break;
  }
  return request({
    url: `/${entity}.${url}/${action}`,
    method: 'POST',
    data: {
      workflowId,
      actionRemark,
      deviceType
    }
  })
}

//退出登录
export function LoginOut() {
  return request({
    url: '/Common.Permit/LoginOut',
    method: 'POST',
  })
}

//刷新缓存
export function RefreshCache() {
  return request({
    url: '/Common.ServerCommon/RefreshCache',
    method: 'POST'
  })
}


export const GetUserAllSettings = () => {    // 设置表头信息
  return request({
    url: `/BasicData.UserGridSetting/GetUserAllSettings`,
    method: 'POST'
  })
}


//获取身份列表
export function getBgUserList(data) {
  return request({
    url: `/BasicData.BgUser/Page`,
    method: 'POST',
    data: data
  })
}


//切换身份
export function RoleSwitchover(data) {
  return request({
    url: `/BasicData.UserLogin/RoleSwitchover`,
    method: 'POST',
    data: data
  })
}


export function RoleQuery(data) {
  return request({
    url: `/Common.Permit_Role/Query`,
    method: 'POST',
    data
  })
}

// 获取架构
export function orgQuery(data) {
  return request({
    url: `/BasicData.OrgStructure/Query`,
    method: 'POST',
    data: data
  })
}


// 获取用户绑定企业微信号的基本信息
export function GetUserWxidBindInfo() {
  return request({
    url: `/BasicData.UserWxidMap/GetUserWxidBindInfo`,
    method: 'POST',
  })
}

// 绑定/重新绑定用户的企业微信号
export function Bid(data) {
  return request({
    url: `/BasicData.UserWxidMap/Bind`,
    method: 'POST',
    data
  })
}

// 解除绑定用户的企业微信号
export function UnBid() {
  return request({
    url: `/BasicData.UserWxidMap/Unbind`,
    method: 'POST',
  })
}

// 推送消息至企业微信
export function SendMsg(todoMsg) {
  return request({
    url: `/BasicData.WxMsg/Send`,
    method: 'POST',
    data: { todoMsg }
  })
}

//修改密码
export function updatePwd(data) {
  return request({
    url: '/BasicData.UserLogin/ModifyPassword',
    method: 'POST',
    data
  })
}

// 获取渠道
export function GetUserChannel(data) {
  return request({
    url: `/BasicData.Project/BidGetChannelByBgUserId`,
    method: 'POST',
    data
  })
};

// 获取对接人
export function GetDockingPeople(data) {
  return request({
    url: `/BasicData.Project/BidGetContactByBgUserId`,
    method: 'POST',
    data
  })
}

// 创建下载链接（分片下载）
export const CreateDownloadRangeLink = (data) => {
  return request({
    url: `/BasicData.ArchivedFile/CreateDownloadRangeLink`,
    method: 'POST',
    data
  })
}

// 获取文件参数、分片请求
export const ShardDownload = (url, method, responseType, data) => {
  return request({
    url,
    data,
    method,
    responseType,
  })
}

// 全部档案文件分类
export const ArchivedFile = (data) => {
  return request({
    url: `/BasicData.ArchivedFileCategory/Query`,
    method: 'POST',
    data
  })
}

// 操作档案文件
export const OperationArchivedFile = (data, path) => {
  return request({
    url: `/BasicData.ArchivedFile/${path}`,
    method: 'POST',
    data
  })
}

// 查询分页数据
export const fetchPagelBasicList = (url, data, sys = 'BasicData') => {
  return request({
    url: `/${sys}.${url}/Page`,
    method: 'POST',
    data
  })
}

// 删除数据
export const deleteList = (url, data, sys = 'BasicData') => {
  return request({
    url: `/${sys}.${url}/Delete`,
    method: 'POST',
    data
  })
}

// 新增、编辑数据
export const updateData = (url, data, type, sys = 'BasicData') => {
  return request({
    url: `/${sys}.${url}/${type}`,
    method: 'POST',
    data
  })
}

//获取单条数据
export const fetchOneData = (url, data, sys = 'BasicData') => {
  return request({
    url: `/${sys}.${url}/Get`,
    method: 'POST',
    data
  })
}

//获取可使用的权限
export const getActionPermit = (actionTagGroup) => {
  return request({
    url: `/Common.Permit/GetActionPermit`,
    method: 'POST',
    data: {
      actionTagGroup
    }
  })
}

// 基础数据接口
export function basic(name, type, data) {
  return request({
    url: `/BasicData.${name}/${type}`,
    method: 'POST',
    data
  })
}

//doc文件预览
export function previewDocFile(logicId, readOnly = false) {
  return request({
    url: `/WopiHost.Wopi/GetWopiUrl`,
    method: 'POST',
    data: {
      logicId,
      readOnly
    },
  })
}

// 财务修改科目
export function ReimbursementWorkflowUpdateData(data) {
  return request({
    url: '/BasicData.ReimbursementWorkflow/UpdateData',
    method: 'POST',
    data: {
      request: data
    }
  })
}

// 获取可切换授权列表
export function getAuthorizationList() {
  return request({
    url: `/BasicData.Account/GetAuthorizationList`,
    method: 'POST'
  })
}

// 切换授权
export function switchAuthorizationList(authorizationId) {
  return request({
    url: `/BasicData.Account/Switch`,
    method: 'POST',
    data: {
      authorizationId
    }
  })
}

//获取入职资料
export function getManualFiles() {
  return request({
    url: `/BasicData.OrgStructure/GetFiles`,
    method: 'POST',
  })
}

// 获取渠道角色
export const roleQuery = () => {
  return request({
    url: `/Common.Permit_Role/Query`,
    method: 'POST',
    data: {
      order: 'ID asc',
      select: 'ID,Name,NameCn,Sys',
      where: "Sys='BasicData' and Name like '%ExternalChannel%'",
    }
  })
};

// 获取岗位
export const JobRankQuery = (where = '1=1') => {
  return request({
    url: `/BasicData.JobRank/Query`,
    method: 'POST',
    data: {
      order: 'Order asc',
      select: 'ID,Name,Title,JobRankType,Order',
      where,
    }
  })
};

// 获取组织架构
export function getOrgPage() {
  return request({
    url: `/BasicData.OrgStructure/Query`,
    method: 'POST',
    data: {
      order: 'order asc',
      select: 'ID,Order,OrgType,Title,ParentID,DepartmentType',
      where: ''
    }
  })
}

// 获取架构父级
export const FindDepartmentOrg = (id) => {
  return request({
    url: `/BasicData.OrgStructure/FindDepartmentOrg`,
    method: 'POST',
    data: {
      id
    }
  })
};

// 手机账号验重
export const IsRepeat = (account) => {
  return request({
    url: `/BasicData.UserLogin/IsRepeat`,
    method: 'POST',
    data: {
      account
    }
  })
};

// 获取登录用户信息
export const getBgUserInfo = (key) => {
  return request({
    url: `/BasicData.BgUser/Get`,
    method: 'POST',
    data: {
      key
    }
  })
};

// 提交入职申请
export const submitEmpJoin = (data) => {
  return request({
    url: `/BasicData.EmpJoin/Submit`,
    method: 'POST',
    data: {
      workflowEntity: data
    }
  })
};

// 提交离职申请
export const submitEmpQuit = (data) => {
  return request({
    url: `/BasicData.EmpQuit/Submit`,
    method: 'POST',
    data
  })
};

// 查询入职ID
export const getEmpJoin = (tel) => {
  return request({
    url: `/BasicData.EmpJoin/Query`,
    method: 'POST',
    data: {
      where: `Status=2 and Tel='${tel}'`
    }
  })
};

// 关键字查询
export const KeywordsSearch= (query) => {    
  return request({
    url: `/BasicData.Keywords/Query`,
    method: 'POST',
    data:{query}
  })
}